/**
 * NEW SKILLS STRUCTURE - IMPLEMENTING DRILL COMBINATIONS
 *
 * This file implements the new skill structure where:
 * - Long drills (18+ minutes) become single skills
 * - Short drills (4-9 minutes) are combined into skills
 * - Each skill has a consistent 15-40 minute duration
 */

export const newSkills = [
  // ============================================================================
  // SOCCER SKILLS (Mostly Single Skills - Long Drills)
  // ============================================================================

  // Single Skills (Long Drills)
  {
    skillId: 1001,
    title: 'Ball Touch Master',
    emoji: '👤',
    description: 'Control the ball with perfect touch',
    equipment: 'Recommended: Soccer ball\nSafe: Small tennis-sized foam ball',
    difficulty: 'intermediate',
    duration: '28 min',
    points: 28,
    drills: [2014], // Single long drill
    sport: 'soccer',
  },
  {
    skillId: 1002,
    title: 'Goal Scorer',
    emoji: '👤',
    description: 'Score goals like a champion',
    equipment: 'Recommended: Small tennis-sized foam ball\nSafe: Soccer ball',
    difficulty: 'intermediate',
    duration: '27 min',
    points: 27,
    drills: [2020], // Single long drill
    sport: 'soccer',
  },
  {
    skillId: 1003,
    title: 'Perfect Passer',
    emoji: '👤',
    description: 'Pass the ball to teammates perfectly',
    equipment: 'Recommended: Small tennis-sized foam ball\nSafe: Soccer ball',
    difficulty: 'intermediate',
    duration: '27 min',
    points: 27,
    drills: [2021], // Single long drill
    sport: 'soccer',
  },
  {
    skillId: 1004,
    title: 'Dribble Master',
    emoji: '👤',
    description: 'Control the ball with your feet',
    equipment: 'Recommended: Soccer ball\nSafe: Small tennis-sized foam ball',
    difficulty: 'intermediate',
    duration: '25 min',
    points: 25,
    drills: [2016], // Single long drill
    sport: 'soccer',
  },
  {
    skillId: 1005,
    title: 'Quick Feet',
    emoji: '👤',
    description: 'Move your feet super fast',
    equipment:
      'Practice: Footwork, balance, and coordination moves\nFocus on: Speed, agility, and movement patterns',
    difficulty: 'intermediate',
    duration: '25 min',
    points: 25,
    drills: [2018], // Single long drill
    sport: 'soccer',
  },
  {
    skillId: 1006,
    title: 'Agile Athlete',
    emoji: '👤',
    description: 'Move quickly and change direction',
    equipment:
      'Practice: Movement patterns and coordination\nFocus on: Agility, balance, and quick direction changes',
    difficulty: 'intermediate',
    duration: '24 min',
    points: 24,
    drills: [2019], // Single long drill
    sport: 'soccer',
  },
  {
    skillId: 1007,
    title: 'Speed Demon',
    emoji: '👤',
    description: 'Run super fast and accelerate quickly',
    equipment:
      'Practice: Speed training and acceleration\nFocus on: Running technique and explosive power',
    difficulty: 'intermediate',
    duration: '23 min',
    points: 23,
    drills: [2012], // Single long drill
    sport: 'soccer',
  },
  {
    skillId: 1008,
    title: 'Balance Master',
    emoji: '👤',
    description: 'Stay balanced and coordinated',
    equipment:
      'Practice: Balance and coordination exercises\nFocus on: Stability, posture, and body control',
    difficulty: 'intermediate',
    duration: '23 min',
    points: 23,
    drills: [2013], // Single long drill
    sport: 'soccer',
  },
  {
    skillId: 1009,
    title: 'Smooth Moves',
    emoji: '👤',
    description: 'Move smoothly and efficiently',
    equipment:
      'Practice: Movement coordination and flow\nFocus on: Smooth transitions and efficient movement',
    difficulty: 'intermediate',
    duration: '21 min',
    points: 21,
    drills: [2015], // Single long drill
    sport: 'soccer',
  },
  {
    skillId: 1010,
    title: 'Soccer Starter',
    emoji: '👤',
    description: 'Learn basic soccer moves like dribbling and ball control',
    equipment: 'Recommended: Soccer ball\nSafe: Small tennis-sized foam ball',
    difficulty: 'beginner',
    duration: '18 min',
    points: 18,
    drills: [2011], // Single long drill
    sport: 'soccer',
  },

  // Combined Skill (Short Drills)
  {
    skillId: 1011,
    title: 'Quick Skills',
    emoji: '👤',
    description: 'Practice fast soccer moves and quick footwork',
    equipment: 'Recommended: Soccer ball\nSafe: Small tennis-sized foam ball',
    difficulty: 'beginner',
    duration: '24 min',
    points: 24,
    drills: [2017, 2022], // Combined short drills
    sport: 'soccer',
  },

  // Partner Drills (Single Skills - Long Drills)
  {
    skillId: 1012,
    title: 'Team Passing',
    emoji: '👥',
    description: 'Practice passing the ball back and forth with your teammate',
    equipment:
      'Recommended: Soccer ball, partner\nSafe: Small tennis-sized foam ball, partner',
    difficulty: 'intermediate',
    duration: '20 min',
    points: 20,
    drills: [2170], // Single partner drill
    sport: 'soccer',
  },
  {
    skillId: 1013,
    title: 'Partner Ball Control',
    emoji: '👥',
    description:
      'Control the ball together with your partner using different moves',
    equipment:
      'Recommended: Soccer ball, partner\nSafe: Small tennis-sized foam ball, partner',
    difficulty: 'intermediate',
    duration: '25 min',
    points: 25,
    drills: [2171], // Single partner drill
    sport: 'soccer',
  },
  {
    skillId: 1014,
    title: 'Team Dribbling',
    emoji: '👥',
    description: 'Dribble the ball together as a team with coordination',
    equipment:
      'Recommended: Soccer ball, partner\nSafe: Small tennis-sized foam ball, partner',
    difficulty: 'intermediate',
    duration: '24 min',
    points: 24,
    drills: [2172], // Single partner drill
    sport: 'soccer',
  },
  {
    skillId: 1015,
    title: 'Partner Moves',
    emoji: '👥',
    description: 'Learn coordinated moves and patterns with your partner',
    equipment:
      'Recommended: Soccer ball, partner\nSafe: Small tennis-sized foam ball, partner',
    difficulty: 'intermediate',
    duration: '23 min',
    points: 23,
    drills: [2173], // Single partner drill
    sport: 'soccer',
  },
  {
    skillId: 1016,
    title: 'Team Movement',
    emoji: '👥',
    description: 'Move together as a team with synchronized patterns',
    equipment:
      'Recommended: Soccer ball, partner\nSafe: Small tennis-sized foam ball, partner',
    difficulty: 'intermediate',
    duration: '24 min',
    points: 24,
    drills: [2174], // Single partner drill
    sport: 'soccer',
  },
  {
    skillId: 1017,
    title: 'Partner Skills',
    emoji: '👥',
    description: 'Master advanced partner moves and complex coordination',
    equipment:
      'Recommended: Small tennis-sized foam ball, partner\nSafe: Soccer ball, partner',
    difficulty: 'advanced',
    duration: '27 min',
    points: 27,
    drills: [2175], // Single partner drill
    sport: 'soccer',
  },
  {
    skillId: 1018,
    title: 'Team Flow',
    emoji: '👥',
    description: 'Flow smoothly with your team',
    equipment:
      'Recommended: Soccer ball, partner\nSafe: Small tennis-sized foam ball, partner',
    difficulty: 'intermediate',
    duration: '22 min',
    points: 22,
    drills: [2176], // Single partner drill
    sport: 'soccer',
  },
  {
    skillId: 1019,
    title: 'Partner Rhythm',
    emoji: '👥',
    description: 'Find rhythm with your partner',
    equipment:
      'Recommended: Soccer ball, partner\nSafe: Small tennis-sized foam ball, partner',
    difficulty: 'intermediate',
    duration: '22 min',
    points: 22,
    drills: [2177], // Single partner drill
    sport: 'soccer',
  },
  {
    skillId: 1020,
    title: 'Quick Team Skills',
    emoji: '👥',
    description: 'Fast partner skills',
    equipment:
      'Recommended: Soccer ball, partner\nSafe: Small tennis-sized foam ball, partner',
    difficulty: 'beginner',
    duration: '8 min',
    points: 8,
    drills: [2178], // Single partner drill
    sport: 'soccer',
  },
  {
    skillId: 1021,
    title: 'Advanced Partners',
    emoji: '👥',
    description: 'Advanced partner techniques',
    equipment:
      'Recommended: Soccer ball, partner\nSafe: Small tennis-sized foam ball, partner',
    difficulty: 'advanced',
    duration: '30 min',
    points: 30,
    drills: [2179], // Single partner drill
    sport: 'soccer',
  },
  {
    skillId: 1022,
    title: 'Partner Champions',
    emoji: '👥',
    description: 'Master partner skills',
    equipment:
      'Recommended: Soccer ball, partner\nSafe: Small tennis-sized foam ball, partner',
    difficulty: 'advanced',
    duration: '32 min',
    points: 32,
    drills: [2180], // Single partner drill
    sport: 'soccer',
  },
  {
    skillId: 1023,
    title: 'Ultimate Partners',
    emoji: '👥',
    description: 'Master partner skills',
    equipment:
      'Recommended: Soccer ball, partner\nSafe: Small tennis-sized foam ball, partner',
    difficulty: 'advanced',
    duration: '33 min',
    points: 33,
    drills: [2181], // Single partner drill
    sport: 'soccer',
  },

  // Full Soccer Workouts (Comprehensive Training Sessions)
  {
    skillId: 1100,
    title: 'Complete Soccer Training',
    emoji: '👤',
    description: 'Complete individual soccer training session',
    equipment: 'Recommended: Soccer ball\nSafe: Small tennis-sized foam ball',
    difficulty: 'advanced',
    duration: '55 min',
    points: 55,
    drills: [2014, 2020, 2016, 2018], // Ball Control, Shooting, Dribbling, Footwork
    sport: 'soccer',
  },
  {
    skillId: 1101,
    title: 'Complete Team Training',
    emoji: '👥',
    description: 'Complete partner soccer training session',
    equipment:
      'Recommended: Soccer ball, partner\nSafe: Small tennis-sized foam ball, partner',
    difficulty: 'advanced',
    duration: '52 min',
    points: 52,
    drills: [2170, 2171, 2172, 2173], // Partner Passing, Control, Dribbling, Coordination
    sport: 'soccer',
  },
  {
    skillId: 1102,
    title: 'Soccer Fundamentals',
    emoji: '👤',
    description: 'Complete fundamentals training session',
    equipment: 'Recommended: Soccer ball\nSafe: Small tennis-sized foam ball',
    difficulty: 'intermediate',
    duration: '48 min',
    points: 48,
    drills: [2011, 2012, 2013, 2015], // Basics, Speed, Coordination, Movement
    sport: 'soccer',
  },
  {
    skillId: 1103,
    title: 'Advanced Soccer Training',
    emoji: '👤',
    description: 'Advanced individual soccer training',
    equipment: 'Recommended: Soccer ball\nSafe: Small tennis-sized foam ball',
    difficulty: 'advanced',
    duration: '58 min',
    points: 58,
    drills: [2014, 2020, 2019, 2016], // Ball Control, Shooting, Agility, Dribbling
    sport: 'soccer',
  },

  // ============================================================================
  // BASKETBALL SKILLS (Individual Drills)
  // ============================================================================

  {
    skillId: 1024,
    title: 'Beginner Dribbling Adventure',
    emoji: '👤',
    description: 'Learn fundamental basketball dribbling skills',
    difficulty: 'beginner',
    duration: '16 min',
    points: 16,
    drills: [2001], // Beginner Dribbling Adventure (960s = 16 min)
    sport: 'basketball',
    skill: 'Dribbling',
  },
  {
    skillId: 1025,
    title: 'Intermediate Dribbling',
    emoji: '👤',
    description: 'Master intermediate basketball dribbling techniques',
    difficulty: 'intermediate',
    duration: '18 min',
    points: 18,
    drills: [2002], // Intermediate Dribbling (1085s = 18 min)
    sport: 'basketball',
    skill: 'Dribbling',
  },
  {
    skillId: 1026,
    title: 'Advanced Dribbling',
    emoji: '👤',
    description: 'Master advanced basketball dribbling techniques',
    difficulty: 'advanced',
    duration: '11 min',
    points: 11,
    drills: [2003], // Advanced Dribbling (664s = 11 min)
    sport: 'basketball',
    skill: 'Dribbling',
  },
  {
    skillId: 1027,
    title: 'Beginner Shooting',
    emoji: '👤',
    description: 'Learn fundamental basketball shooting skills',
    difficulty: 'beginner',
    duration: '16 min',
    points: 16,
    drills: [2004], // Beginner Shooting (960s = 16 min)
    sport: 'basketball',
    skill: 'Shooting',
  },
  {
    skillId: 1028,
    title: 'Super Shooter Challenge',
    emoji: '👤',
    description: 'Master intermediate basketball shooting techniques',
    difficulty: 'intermediate',
    duration: '18 min',
    points: 18,
    drills: [2005], // Super Shooter Challenge (1080s = 18 min)
    sport: 'basketball',
    skill: 'Shooting',
  },
  {
    skillId: 1029,
    title: 'Basketball Defense Challenge',
    emoji: '👤',
    description: 'Learn fundamental basketball defense skills',
    difficulty: 'beginner',
    duration: '16 min',
    points: 16,
    drills: [2007], // Basketball Defense Challenge (945s = 16 min)
    sport: 'basketball',
    skill: 'Defense',
  },
  {
    skillId: 1030,
    title: 'Intermediate Defense',
    emoji: '👤',
    description: 'Master intermediate basketball defense techniques',
    difficulty: 'intermediate',
    duration: '18 min',
    points: 18,
    drills: [2008], // Intermediate Defense (1065s = 18 min)
    sport: 'basketball',
    skill: 'Defense',
  },
  {
    skillId: 1031,
    title: 'Advanced Defense',
    emoji: '👤',
    description: 'Master advanced basketball defense techniques',
    difficulty: 'advanced',
    duration: '19 min',
    points: 19,
    drills: [2009], // Advanced Defense (1135s = 19 min)
    sport: 'basketball',
    skill: 'Defense',
  },
  {
    skillId: 1032,
    title: 'Complete Individual Basketball',
    emoji: '👤',
    description: 'Complete basketball training session with all skills',
    difficulty: 'advanced',
    duration: '28 min',
    points: 28,
    drills: [2010], // Complete Individual Basketball (1674s = 28 min)
    sport: 'basketball',
    skill: 'Complete',
  },

  // ============================================================================
  // BASKETBALL COMBINED SKILLS (New)
  // ============================================================================

  {
    skillId: 1033,
    title: 'Beginner Complete Basketball',
    emoji: '👤',
    description:
      'Complete beginner basketball training with dribbling, shooting, and defense',
    difficulty: 'beginner',
    duration: '48 min',
    points: 48,
    drills: [2001, 2004, 2007], // Beginner Dribbling, Beginner Shooting, Beginner Defense
    sport: 'basketball',
    skill: 'Complete',
  },
  {
    skillId: 1034,
    title: 'Intermediate Complete Basketball',
    emoji: '👤',
    description:
      'Complete intermediate basketball training with dribbling, shooting, and defense',
    difficulty: 'intermediate',
    duration: '54 min',
    points: 54,
    drills: [2002, 2005, 2008], // Intermediate Dribbling, Intermediate Shooting, Intermediate Defense
    sport: 'basketball',
    skill: 'Complete',
  },
  {
    skillId: 1035,
    title: 'Advanced Complete Basketball',
    emoji: '👤',
    description:
      'Complete advanced basketball training with dribbling, shooting, and defense',
    difficulty: 'advanced',
    duration: '57 min',
    points: 57,
    drills: [2003, 2006, 2009], // Advanced Dribbling, Advanced Shooting, Advanced Defense
    sport: 'basketball',
    skill: 'Complete',
  },

  // ============================================================================
  // BASEBALL SKILLS (Individual Drills)
  // ============================================================================

  {
    skillId: 1240,
    title: 'Beginner Hitting Basics',
    emoji: '👤',
    description: 'Learn fundamental baseball hitting techniques',
    difficulty: 'beginner',
    duration: '16 min',
    points: 16,
    drills: [2140], // Beginner Hitting Basics (970s = 16 min)
    sport: 'baseball',
    skill: 'Hitting',
  },
  {
    skillId: 1241,
    title: 'Intermediate Hitting Contact',
    emoji: '👤',
    description: 'Master intermediate hitting contact and timing',
    difficulty: 'intermediate',
    duration: '13 min',
    points: 13,
    drills: [2141], // Intermediate Hitting Contact and Timing (805s = 13 min)
    sport: 'baseball',
    skill: 'Hitting',
  },
  {
    skillId: 1242,
    title: 'Advanced Hitting Power',
    emoji: '👤',
    description: 'Master advanced hitting bat path and power',
    difficulty: 'advanced',
    duration: '16 min',
    points: 16,
    drills: [2142], // Advanced Hitting Bat Path and Power (960s = 16 min)
    sport: 'baseball',
    skill: 'Hitting',
  },
  {
    skillId: 1243,
    title: 'Beginner Fielding Basics',
    emoji: '👤',
    description: 'Learn fundamental baseball fielding techniques',
    difficulty: 'beginner',
    duration: '14 min',
    points: 14,
    drills: [2143], // Beginner Fielding Basics (815s = 14 min)
    sport: 'baseball',
    skill: 'Fielding',
  },
  {
    skillId: 1244,
    title: 'Intermediate Fielding Footwork',
    emoji: '👤',
    description: 'Master intermediate fielding footwork and movement',
    difficulty: 'intermediate',
    duration: '14 min',
    points: 14,
    drills: [2144], // Intermediate Fielding Footwork (835s = 14 min)
    sport: 'baseball',
    skill: 'Fielding',
  },
  {
    skillId: 1245,
    title: 'Beginner Throwing Basics',
    emoji: '👤',
    description: 'Learn fundamental baseball throwing techniques',
    difficulty: 'beginner',
    duration: '14 min',
    points: 14,
    drills: [2146], // Beginner Throwing Basics (820s = 14 min)
    sport: 'baseball',
    skill: 'Throwing',
  },
  {
    skillId: 1246,
    title: 'Intermediate Throwing Accuracy',
    emoji: '👤',
    description: 'Master intermediate throwing accuracy and control',
    difficulty: 'intermediate',
    duration: '15 min',
    points: 15,
    drills: [2147], // Intermediate Throwing Accuracy (925s = 15 min)
    sport: 'baseball',
    skill: 'Throwing',
  },
  {
    skillId: 1247,
    title: 'Advanced Throwing Quick Release',
    emoji: '👤',
    description: 'Master advanced throwing quick release and speed',
    difficulty: 'advanced',
    duration: '14 min',
    points: 14,
    drills: [2148], // Advanced Throwing Quick Release (845s = 14 min)
    sport: 'baseball',
    skill: 'Throwing',
  },
  {
    skillId: 1248,
    title: 'Complete Individual Baseball',
    emoji: '👤',
    description: 'Complete baseball training session with all skills',
    difficulty: 'advanced',
    duration: '19 min',
    points: 19,
    drills: [2149], // Complete Individual Baseball (1160s = 19 min)
    sport: 'baseball',
    skill: 'Complete',
  },

  // ============================================================================
  // BASEBALL PARTNER SKILLS (Individual Drills)
  // ============================================================================

  {
    skillId: 1253,
    title: 'Partner Toss and Catch Basics',
    emoji: '👥',
    description: 'Learn fundamental partner baseball skills',
    difficulty: 'beginner',
    duration: '26 min',
    points: 26,
    drills: [2160], // Partner Toss and Catch Basics (1565s = 26 min)
    sport: 'baseball',
    skill: 'Partner',
  },
  {
    skillId: 1254,
    title: 'Partner Grounder Roll and Scoop',
    emoji: '👥',
    description: 'Master partner ground ball techniques',
    difficulty: 'beginner',
    duration: '20 min',
    points: 20,
    drills: [2161], // Partner Grounder Roll and Scoop (1190s = 20 min)
    sport: 'baseball',
    skill: 'Partner',
  },
  {
    skillId: 1255,
    title: 'Partner Step and Throw Accuracy',
    emoji: '👥',
    description: 'Master partner throwing accuracy',
    difficulty: 'intermediate',
    duration: '18 min',
    points: 18,
    drills: [2162], // Partner Step and Throw Accuracy (1095s = 18 min)
    sport: 'baseball',
    skill: 'Partner',
  },
  {
    skillId: 1256,
    title: 'Partner Quick Hands Challenge',
    emoji: '👥',
    description: 'Master partner quick hands and coordination',
    difficulty: 'intermediate',
    duration: '30 min',
    points: 30,
    drills: [2163], // Partner Quick Hands Challenge (1800s = 30 min)
    sport: 'baseball',
    skill: 'Partner',
  },
  {
    skillId: 1257,
    title: 'Partner Pop Fly Call and Catch',
    emoji: '👥',
    description: 'Master partner pop fly catching',
    difficulty: 'advanced',
    duration: '21 min',
    points: 21,
    drills: [2164], // Partner Pop Fly Call and Catch (1260s = 21 min)
    sport: 'baseball',
    skill: 'Partner',
  },
  {
    skillId: 1258,
    title: 'Partner Relay Feet and Aim',
    emoji: '👥',
    description: 'Master partner relay techniques',
    difficulty: 'advanced',
    duration: '30 min',
    points: 30,
    drills: [2165], // Partner Relay Feet and Aim (1800s = 30 min)
    sport: 'baseball',
    skill: 'Partner',
  },

  // ============================================================================
  // BASEBALL COMBINED SKILLS (Multiple Drills)
  // ============================================================================

  {
    skillId: 1250,
    title: 'Beginner Baseball',
    emoji: '👤',
    description:
      'Complete beginner baseball training with hitting, fielding, and throwing',
    difficulty: 'beginner',
    duration: '44 min',
    points: 44,
    drills: [2140, 2143, 2146], // Beginner Hitting + Fielding + Throwing
    sport: 'baseball',
    skill: 'Complete',
  },
  {
    skillId: 1251,
    title: 'Intermediate Baseball',
    emoji: '👤',
    description:
      'Complete intermediate baseball training with hitting, fielding, and throwing',
    difficulty: 'intermediate',
    duration: '42 min',
    points: 42,
    drills: [2141, 2144, 2147], // Intermediate Hitting + Fielding + Throwing
    sport: 'baseball',
    skill: 'Complete',
  },
  {
    skillId: 1252,
    title: 'Advanced Baseball',
    emoji: '👤',
    description:
      'Complete advanced baseball training with hitting, fielding, and throwing',
    difficulty: 'advanced',
    duration: '44 min',
    points: 44,
    drills: [2142, 2144, 2148], // Advanced Hitting (16) + Fielding (14) + Throwing (14) = 44 min
    sport: 'baseball',
    skill: 'Complete',
  },

  // ============================================================================
  // BASEBALL PARTNER SKILLS (New)
  // ============================================================================

  {
    skillId: 1028.1,
    title: 'Baseball Partner Basics',
    emoji: '👥',
    description: 'Learn baseball with a partner',
    equipment:
      'Recommended: Soft ball or rolled socks\nRequired: Partner\nOptional: Gloves',
    difficulty: 'beginner',
    duration: '30 min',
    points: 30,
    drills: [2160, 2161, 2162], // Combined partner drills
    sport: 'baseball',
  },
  {
    skillId: 1028.2,
    title: 'Baseball Partner Skills',
    emoji: '👥',
    description: 'Master baseball partner techniques',
    equipment:
      'Recommended: Soft ball or rolled socks\nRequired: Partner\nOptional: Gloves',
    difficulty: 'intermediate',
    duration: '32 min',
    points: 32,
    drills: [2163, 2164, 2165], // Combined partner drills
    sport: 'baseball',
  },

  // ============================================================================
  // BOXING SKILLS (Individual Skills)
  // ============================================================================

  // ============================================================================
  // KARATE SKILLS (Individual Skills)
  // ============================================================================

  {
    skillId: 1036,
    title: 'Beginner Stances',
    emoji: '👤',
    description: 'Learn fundamental karate stances and footwork',
    difficulty: 'beginner',
    duration: '30 min',
    points: 30,
    drills: [2031], // Beginner Stances
    sport: 'karate',
    skill: 'Stances',
  },
  {
    skillId: 1037,
    title: 'Intermediate Stances',
    emoji: '👤',
    description: 'Master intermediate karate stances and positioning',
    difficulty: 'intermediate',
    duration: '30 min',
    points: 30,
    drills: [2032], // Intermediate Stances
    sport: 'karate',
    skill: 'Stances',
  },
  {
    skillId: 1038,
    title: 'Advanced Stances',
    emoji: '👤',
    description: 'Master advanced karate stances and stability',
    difficulty: 'advanced',
    duration: '30 min',
    points: 30,
    drills: [2033], // Advanced Stances
    sport: 'karate',
    skill: 'Stances',
  },
  {
    skillId: 1039,
    title: 'Beginner Strikes',
    emoji: '👤',
    description: 'Learn fundamental karate striking techniques',
    difficulty: 'beginner',
    duration: '30 min',
    points: 30,
    drills: [2034], // Beginner Strikes
    sport: 'karate',
    skill: 'Strikes',
  },
  {
    skillId: 1040,
    title: 'Intermediate Strikes',
    emoji: '👤',
    description: 'Master intermediate karate striking techniques',
    difficulty: 'intermediate',
    duration: '30 min',
    points: 30,
    drills: [2035], // Intermediate Strikes
    sport: 'karate',
    skill: 'Strikes',
  },
  {
    skillId: 1041,
    title: 'Advanced Strikes',
    emoji: '👤',
    description: 'Master advanced karate striking techniques',
    difficulty: 'advanced',
    duration: '30 min',
    points: 30,
    drills: [2036], // Advanced Strikes
    sport: 'karate',
    skill: 'Strikes',
  },
  {
    skillId: 1042,
    title: 'Beginner Blocks',
    emoji: '👤',
    description: 'Learn fundamental karate blocking techniques',
    difficulty: 'beginner',
    duration: '30 min',
    points: 30,
    drills: [2037], // Beginner Blocks
    sport: 'karate',
    skill: 'Blocks',
  },
  {
    skillId: 1043,
    title: 'Intermediate Blocks',
    emoji: '👤',
    description: 'Master intermediate karate blocking techniques',
    difficulty: 'intermediate',
    duration: '30 min',
    points: 30,
    drills: [2038], // Intermediate Blocks
    sport: 'karate',
    skill: 'Blocks',
  },
  {
    skillId: 1044,
    title: 'Advanced Blocks',
    emoji: '👤',
    description: 'Master advanced karate blocking techniques',
    difficulty: 'advanced',
    duration: '30 min',
    points: 30,
    drills: [2039], // Advanced Blocks
    sport: 'karate',
    skill: 'Blocks',
  },
  {
    skillId: 1045,
    title: 'Complete Individual Karate',
    emoji: '👤',
    description: 'Complete karate training session with all skills',
    difficulty: 'advanced',
    duration: '60 min',
    points: 60,
    drills: [2040], // Complete Individual Karate
    sport: 'karate',
    skill: 'Complete',
  },

  // ============================================================================
  // KARATE COMBINED SKILLS (Multiple Drills)
  // ============================================================================

  {
    skillId: 1193,
    title: 'Beginner Karate Combat',
    emoji: '🥋',
    description: 'Learn fundamental karate striking and blocking techniques',
    difficulty: 'beginner',
    duration: '60 min',
    points: 60,
    drills: [2034, 2037], // Beginner Strikes + Beginner Blocks
    sport: 'karate',
    skill: 'Combat',
  },
  {
    skillId: 1194,
    title: 'Intermediate Karate Combat',
    emoji: '🥋',
    description: 'Master intermediate karate striking and blocking techniques',
    difficulty: 'intermediate',
    duration: '60 min',
    points: 60,
    drills: [2035, 2038], // Intermediate Strikes + Intermediate Blocks
    sport: 'karate',
    skill: 'Combat',
  },
  {
    skillId: 1195,
    title: 'Advanced Karate Combat',
    emoji: '🥋',
    description: 'Master advanced karate striking and blocking techniques',
    difficulty: 'advanced',
    duration: '60 min',
    points: 60,
    drills: [2036, 2039], // Advanced Strikes + Advanced Blocks
    sport: 'karate',
    skill: 'Combat',
  },

  // ============================================================================
  // VOLLEYBALL SKILLS (Individual Skills)
  // ============================================================================

  {
    skillId: 1046,
    title: 'Beginner Passing',
    emoji: '👤',
    description: 'Learn fundamental volleyball passing and ball control',
    difficulty: 'beginner',
    duration: '30 min',
    points: 30,
    drills: [2051], // Beginner Passing
    sport: 'volleyball',
    skill: 'Passing',
  },
  {
    skillId: 1047,
    title: 'Intermediate Passing',
    emoji: '👤',
    description: 'Master intermediate volleyball passing techniques',
    difficulty: 'intermediate',
    duration: '45 min',
    points: 45,
    drills: [2052], // Intermediate Passing
    sport: 'volleyball',
    skill: 'Passing',
  },
  {
    skillId: 1048,
    title: 'Advanced Passing',
    emoji: '👤',
    description: 'Master advanced volleyball passing and precision',
    difficulty: 'advanced',
    duration: '45 min',
    points: 45,
    drills: [2053], // Advanced Passing
    sport: 'volleyball',
    skill: 'Passing',
  },
  {
    skillId: 1049,
    title: 'Beginner Setting',
    emoji: '👤',
    description: 'Learn fundamental volleyball setting techniques',
    difficulty: 'beginner',
    duration: '30 min',
    points: 30,
    drills: [2054], // Beginner Setting
    sport: 'volleyball',
    skill: 'Setting',
  },
  {
    skillId: 1050,
    title: 'Intermediate Setting',
    emoji: '👤',
    description: 'Master intermediate volleyball setting skills',
    difficulty: 'intermediate',
    duration: '45 min',
    points: 45,
    drills: [2055], // Intermediate Setting
    sport: 'volleyball',
    skill: 'Setting',
  },
  {
    skillId: 1051,
    title: 'Advanced Setting',
    emoji: '👤',
    description: 'Master advanced volleyball setting and precision',
    difficulty: 'advanced',
    duration: '45 min',
    points: 45,
    drills: [2056], // Advanced Setting
    sport: 'volleyball',
    skill: 'Setting',
  },
  {
    skillId: 1052,
    title: 'Beginner Serving',
    emoji: '👤',
    description: 'Learn fundamental volleyball serving techniques',
    difficulty: 'beginner',
    duration: '30 min',
    points: 30,
    drills: [2057], // Beginner Serving
    sport: 'volleyball',
    skill: 'Serving',
  },
  {
    skillId: 1053,
    title: 'Intermediate Serving',
    emoji: '👤',
    description: 'Master intermediate volleyball serving skills',
    difficulty: 'intermediate',
    duration: '45 min',
    points: 45,
    drills: [2058], // Intermediate Serving
    sport: 'volleyball',
    skill: 'Serving',
  },
  {
    skillId: 1054,
    title: 'Advanced Serving',
    emoji: '👤',
    description: 'Master advanced volleyball serving and accuracy',
    difficulty: 'advanced',
    duration: '45 min',
    points: 45,
    drills: [2059], // Advanced Serving
    sport: 'volleyball',
    skill: 'Serving',
  },
  {
    skillId: 1055,
    title: 'Complete Individual Volleyball',
    emoji: '👤',
    description: 'Complete volleyball training session with all skills',
    difficulty: 'advanced',
    duration: '60 min',
    points: 60,
    drills: [2060], // Complete Individual Volleyball
    sport: 'volleyball',
    skill: 'Complete',
  },

  // ============================================================================
  // VOLLEYBALL PARTNER SKILLS (New)
  // ============================================================================

  {
    skillId: 1048.1,
    title: 'Volleyball Partner Basics',
    emoji: '👥',
    description: 'Learn volleyball with a partner',
    equipment:
      'Recommended: Volleyball\nRequired: Partner\nOptional: Wall space',
    difficulty: 'beginner',
    duration: '30 min',
    points: 30,
    drills: [2080, 2081, 2082], // Combined partner drills
    sport: 'volleyball',
  },
  {
    skillId: 1048.2,
    title: 'Volleyball Partner Skills',
    emoji: '👥',
    description: 'Master volleyball partner techniques',
    equipment:
      'Recommended: Volleyball\nRequired: Partner\nOptional: Wall space',
    difficulty: 'intermediate',
    duration: '32 min',
    points: 32,
    drills: [2083, 2084, 2085], // Combined partner drills
    sport: 'volleyball',
  },
  {
    skillId: 1048.3,
    title: 'Advanced Volleyball Partner',
    emoji: '👥',
    description: 'Master advanced volleyball partner skills',
    equipment:
      'Recommended: Volleyball\nRequired: Partner\nOptional: Wall space',
    difficulty: 'advanced',
    duration: '34 min',
    points: 34,
    drills: [2086, 2087, 2088, 2089], // Combined partner drills
    sport: 'volleyball',
  },

  // ============================================================================
  // DANCE SKILLS (Individual Skills)
  // ============================================================================

  {
    skillId: 1200,
    title: 'Beginner Movement',
    emoji: '👤',
    description: 'Learn fundamental dance movement and coordination',
    difficulty: 'beginner',
    duration: '18 min',
    points: 18,
    drills: [2041], // Beginner Movement
    sport: 'dance',
    skill: 'Movement',
  },
  {
    skillId: 1201,
    title: 'Intermediate Movement',
    emoji: '👤',
    description: 'Master intermediate dance movement and agility',
    difficulty: 'intermediate',
    duration: '11 min',
    points: 11,
    drills: [2042], // Intermediate Movement
    sport: 'dance',
    skill: 'Movement',
  },
  {
    skillId: 1202,
    title: 'Advanced Movement',
    emoji: '👤',
    description: 'Master advanced dance movement and speed',
    difficulty: 'advanced',
    duration: '19 min',
    points: 19,
    drills: [2043], // Advanced Movement
    sport: 'dance',
    skill: 'Movement',
  },
  {
    skillId: 1203,
    title: 'Beginner Rhythm',
    emoji: '👤',
    description: 'Learn fundamental dance rhythm and timing',
    difficulty: 'beginner',
    duration: '16 min',
    points: 16,
    drills: [2044], // Beginner Rhythm
    sport: 'dance',
    skill: 'Rhythm',
  },
  {
    skillId: 1204,
    title: 'Intermediate Rhythm',
    emoji: '👤',
    description: 'Master intermediate dance rhythm and coordination',
    difficulty: 'intermediate',
    duration: '16 min',
    points: 16,
    drills: [2045], // Intermediate Rhythm
    sport: 'dance',
    skill: 'Rhythm',
  },
  {
    skillId: 1205,
    title: 'Robot Rhythm Challenge',
    emoji: '👤',
    description: 'Master advanced robot-style dance rhythm',
    difficulty: 'advanced',
    duration: '17 min',
    points: 17,
    drills: [2046], // Robot Rhythm Challenge
    sport: 'dance',
    skill: 'Rhythm',
  },
  {
    skillId: 1206,
    title: 'Beginner Choreography',
    emoji: '👤',
    description: 'Learn fundamental dance choreography and creativity',
    difficulty: 'beginner',
    duration: '22 min',
    points: 22,
    drills: [2047], // Beginner Choreography
    sport: 'dance',
    skill: 'Choreography',
  },
  {
    skillId: 1207,
    title: 'Intermediate Choreography',
    emoji: '👤',
    description: 'Master intermediate dance choreography and style',
    difficulty: 'intermediate',
    duration: '18 min',
    points: 18,
    drills: [2048], // Intermediate Choreography
    sport: 'dance',
    skill: 'Choreography',
  },
  {
    skillId: 1208,
    title: 'Advanced Choreography',
    emoji: '👤',
    description: 'Master advanced dance choreography and artistry',
    difficulty: 'advanced',
    duration: '20 min',
    points: 20,
    drills: [2049], // Advanced Choreography
    sport: 'dance',
    skill: 'Choreography',
  },
  {
    skillId: 1209,
    title: 'Complete Individual Dance',
    emoji: '👤',
    description: 'Complete dance training session with all skills',
    difficulty: 'advanced',
    duration: '21 min',
    points: 21,
    drills: [2050], // Complete Individual Dance
    sport: 'dance',
    skill: 'Complete',
  },

  // ============================================================================
  // DANCE COMBINED SKILLS (Multiple Drills)
  // ============================================================================

  {
    skillId: 1210,
    title: 'Beginner Dance',
    emoji: '👤',
    description:
      'Complete beginner dance training with movement, rhythm, and choreography',
    difficulty: 'beginner',
    duration: '56 min',
    points: 56,
    drills: [2041, 2044, 2047], // Beginner Movement + Beginner Rhythm + Beginner Choreography
    sport: 'dance',
    skill: 'Complete',
  },
  {
    skillId: 1211,
    title: 'Intermediate Dance',
    emoji: '👤',
    description:
      'Complete intermediate dance training with movement, rhythm, and choreography',
    difficulty: 'intermediate',
    duration: '45 min',
    points: 45,
    drills: [2042, 2045, 2048], // Intermediate Movement + Intermediate Rhythm + Intermediate Choreography
    sport: 'dance',
    skill: 'Complete',
  },
  {
    skillId: 1212,
    title: 'Advanced Dance',
    emoji: '👤',
    description:
      'Complete advanced dance training with movement, rhythm, and choreography',
    difficulty: 'advanced',
    duration: '56 min',
    points: 56,
    drills: [2043, 2046, 2049], // Advanced Movement + Robot Rhythm + Advanced Choreography
    sport: 'dance',
    skill: 'Complete',
  },

  // ============================================================================
  // BALLET SKILLS (Individual Drills)
  // ============================================================================

  {
    skillId: 1220,
    title: 'Beginner Ballet Basics',
    emoji: '👤',
    description: 'Learn fundamental ballet positions and movements',
    difficulty: 'beginner',
    duration: '30 min',
    points: 30,
    drills: [2190], // Beginner Ballet Basics
    sport: 'ballet',
    skill: 'Basics',
  },
  {
    skillId: 1221,
    title: 'Intermediate Ballet Basics',
    emoji: '👤',
    description: 'Master intermediate ballet positions and movements',
    difficulty: 'intermediate',
    duration: '23 min',
    points: 23,
    drills: [2191], // Intermediate Ballet Basics
    sport: 'ballet',
    skill: 'Basics',
  },
  {
    skillId: 1222,
    title: 'Advanced Ballet Basics',
    emoji: '👤',
    description: 'Master advanced ballet positions and movements',
    difficulty: 'advanced',
    duration: '22 min',
    points: 22,
    drills: [2192], // Advanced Ballet Basics
    sport: 'ballet',
    skill: 'Basics',
  },
  {
    skillId: 1223,
    title: 'Beginner Ballet Movement',
    emoji: '👤',
    description: 'Learn fundamental ballet steps and coordination',
    difficulty: 'beginner',
    duration: '19 min',
    points: 19,
    drills: [2193], // Beginner Ballet Movement
    sport: 'ballet',
    skill: 'Movement',
  },
  {
    skillId: 1224,
    title: 'Intermediate Ballet Movement',
    emoji: '👤',
    description: 'Master intermediate ballet steps and coordination',
    difficulty: 'intermediate',
    duration: '40 min',
    points: 40,
    drills: [2194], // Intermediate Ballet Movement
    sport: 'ballet',
    skill: 'Movement',
  },
  {
    skillId: 1225,
    title: 'Advanced Ballet Movement',
    emoji: '👤',
    description: 'Master advanced ballet steps and coordination',
    difficulty: 'advanced',
    duration: '42 min',
    points: 42,
    drills: [2195], // Advanced Ballet Movement
    sport: 'ballet',
    skill: 'Movement',
  },
  {
    skillId: 1226,
    title: 'Beginner Ballet Grace',
    emoji: '👤',
    description: 'Learn fundamental graceful movements and flow',
    difficulty: 'beginner',
    duration: '25 min',
    points: 25,
    drills: [2196], // Beginner Ballet Grace
    sport: 'ballet',
    skill: 'Grace',
  },
  {
    skillId: 1227,
    title: 'Intermediate Ballet Grace',
    emoji: '👤',
    description: 'Master intermediate graceful movements and flow',
    difficulty: 'intermediate',
    duration: '40 min',
    points: 40,
    drills: [2197], // Intermediate Ballet Grace
    sport: 'ballet',
    skill: 'Grace',
  },
  {
    skillId: 1228,
    title: 'Advanced Ballet Grace',
    emoji: '👤',
    description: 'Master advanced graceful movements and flow',
    difficulty: 'advanced',
    duration: '38 min',
    points: 38,
    drills: [2198], // Advanced Ballet Grace
    sport: 'ballet',
    skill: 'Grace',
  },
  {
    skillId: 1229,
    title: 'Complete Ballet',
    emoji: '👤',
    description: 'Complete ballet training session with all skills',
    difficulty: 'advanced',
    duration: '60 min',
    points: 60,
    drills: [2199], // Complete Ballet
    sport: 'ballet',
    skill: 'Complete',
  },

  // ============================================================================
  // BALLET COMBINED SKILLS (Multiple Drills)
  // ============================================================================

  {
    skillId: 1230,
    title: 'Beginner Ballet',
    emoji: '👤',
    description:
      'Complete beginner ballet training with basics, movement, and grace',
    difficulty: 'beginner',
    duration: '74 min',
    points: 74,
    drills: [2190, 2193, 2196], // Beginner Basics + Beginner Movement + Beginner Grace
    sport: 'ballet',
    skill: 'Complete',
  },
  {
    skillId: 1231,
    title: 'Intermediate Ballet',
    emoji: '👤',
    description:
      'Complete intermediate ballet training with basics, movement, and grace',
    difficulty: 'intermediate',
    duration: '103 min',
    points: 103,
    drills: [2191, 2194, 2197], // Intermediate Basics + Intermediate Movement + Intermediate Grace
    sport: 'ballet',
    skill: 'Complete',
  },
  {
    skillId: 1232,
    title: 'Advanced Ballet',
    emoji: '👤',
    description:
      'Complete advanced ballet training with basics, movement, and grace',
    difficulty: 'advanced',
    duration: '102 min',
    points: 102,
    drills: [2192, 2195, 2198], // Advanced Basics + Advanced Movement + Advanced Grace
    sport: 'ballet',
    skill: 'Complete',
  },

  // ============================================================================
  // YOGA SKILLS (Single Skills - Good Lengths)
  // ============================================================================

  {
    skillId: 1062,
    title: 'Beginner Yoga Basics',
    emoji: '🧘',
    description: 'Learn fundamental yoga poses and breathing',
    difficulty: 'beginner',
    duration: '30 min',
    points: 30,
    drills: [2100], // Beginner Yoga Basics
    sport: 'yoga',
    skill: 'Basics',
  },
  {
    skillId: 1063,
    title: 'Intermediate Yoga Basics',
    emoji: '🌊',
    description: 'Build on basic yoga skills with harder poses',
    difficulty: 'intermediate',
    duration: '45 min',
    points: 45,
    drills: [2101], // Intermediate Yoga Basics
    sport: 'yoga',
    skill: 'Basics',
  },
  {
    skillId: 1064,
    title: 'Advanced Yoga Basics',
    emoji: '⚡',
    description: 'Master challenging yoga poses and coordination',
    difficulty: 'advanced',
    duration: '45 min',
    points: 45,
    drills: [2102], // Advanced Yoga Basics
    sport: 'yoga',
    skill: 'Basics',
  },

  // ============================================================================
  // YOGA COMPLETE WORKOUTS (Combined Skills)
  // ============================================================================

  {
    skillId: 1190,
    title: 'Complete Yoga - Beginner',
    emoji: '🧘',
    description: 'Complete beginner yoga training session',
    difficulty: 'beginner',
    duration: '30 min',
    points: 30,
    drills: [2100], // Beginner Yoga Basics
    sport: 'yoga',
    skill: 'Complete',
  },
  {
    skillId: 1191,
    title: 'Complete Yoga - Intermediate',
    emoji: '🌊',
    description: 'Complete intermediate yoga training session',
    difficulty: 'intermediate',
    duration: '45 min',
    points: 45,
    drills: [2101], // Intermediate Yoga Basics
    sport: 'yoga',
    skill: 'Complete',
  },
  {
    skillId: 1192,
    title: 'Complete Yoga - Advanced',
    emoji: '⚡',
    description: 'Complete advanced yoga training session',
    difficulty: 'advanced',
    duration: '45 min',
    points: 45,
    drills: [2102], // Advanced Yoga Basics
    sport: 'yoga',
    skill: 'Complete',
  },

  // ============================================================================
  // TAEKWONDO SKILLS (Combined Skills)
  // ============================================================================

  {
    skillId: 1065,
    title: 'Taekwondo Basics',
    emoji: '☯',
    description: 'Learn fundamental taekwondo skills',
    difficulty: 'beginner',
    duration: '25 min',
    points: 25,
    drills: [2120, 2121, 2122, 2123, 2124], // Combined drills
    sport: 'taekwondo',
  },
  {
    skillId: 1066,
    title: 'Advanced Taekwondo',
    emoji: '☯',
    description: 'Master advanced taekwondo techniques',
    difficulty: 'advanced',
    duration: '24 min',
    points: 24,
    drills: [2125, 2126, 2127, 2128, 2129, 2130], // Combined drills
    sport: 'taekwondo',
  },

  // ============================================================================
  // MOVEMENT COORDINATION SKILLS (Combined Skills)
  // ============================================================================

  {
    skillId: 1071,
    title: 'Movement Basics',
    emoji: '👤',
    description: 'Learn fundamental movement skills',
    difficulty: 'beginner',
    duration: '25 min',
    points: 25,
    drills: [2061, 2062, 2063, 2064], // Combined drills
    sport: 'movement-coordination',
  },
  {
    skillId: 1072,
    title: 'Movement Skills',
    emoji: '👤',
    description: 'Master movement techniques',
    difficulty: 'intermediate',
    duration: '28 min',
    points: 28,
    drills: [2065, 2066, 2067, 2068, 2069], // Combined drills
    sport: 'movement-coordination',
  },

  // ============================================================================
  // RUNNING TECHNIQUE SKILLS (Individual Skills)
  // ============================================================================

  {
    skillId: 1150,
    title: 'Running Form',
    emoji: '🏃',
    description: 'Learn fundamental running form and technique',
    difficulty: 'beginner',
    duration: '18 min',
    points: 18,
    drills: [2110], // Running Form
    sport: 'running-technique',
    skill: 'Form',
  },
  {
    skillId: 1151,
    title: 'Speed & Agility',
    emoji: '⚡',
    description: 'Master speed and agility techniques',
    difficulty: 'beginner',
    duration: '18 min',
    points: 18,
    drills: [2113], // Speed & Agility
    sport: 'running-technique',
    skill: 'Speed',
  },
  {
    skillId: 1152,
    title: 'Beginner Endurance',
    emoji: '🫁',
    description: 'Build endurance with proper running form',
    difficulty: 'beginner',
    duration: '22 min',
    points: 22,
    drills: [2116], // Beginner Endurance
    sport: 'running-technique',
    skill: 'Endurance',
  },
  {
    skillId: 1153,
    title: 'Intermediate Endurance',
    emoji: '🫁',
    description: 'Advanced endurance training with proper form',
    difficulty: 'intermediate',
    duration: '45 min',
    points: 45,
    drills: [2117], // Intermediate Endurance
    sport: 'running-technique',
    skill: 'Endurance',
  },

  // ============================================================================
  // RUNNING TECHNIQUE SKILLS (Complete Workouts)
  // ============================================================================

  {
    skillId: 1154,
    title: 'Complete Running - Beginner',
    emoji: '🏃',
    description: 'Complete beginner running training session',
    difficulty: 'beginner',
    duration: '58 min',
    points: 58,
    drills: [2110, 2113, 2116], // Running Form + Speed & Agility + Beginner Endurance
    sport: 'running-technique',
    skill: 'Complete',
  },
  {
    skillId: 1155,
    title: 'Complete Running - Intermediate',
    emoji: '🏃',
    description: 'Complete intermediate running training session',
    difficulty: 'intermediate',
    duration: '103 min',
    points: 103,
    drills: [2110, 2113, 2116, 2117], // All running drills
    sport: 'running-technique',
    skill: 'Complete',
  },

  // ============================================================================
  // TAEKWONDO SKILLS (Individual Skills)
  // ============================================================================

  {
    skillId: 1160,
    title: 'Beginner Taekwondo Basics',
    emoji: '☯',
    description: 'Learn fundamental taekwondo basics and stances',
    difficulty: 'beginner',
    duration: '16 min',
    points: 16,
    drills: [2120], // Beginner Taekwondo Basics
    sport: 'taekwondo',
    skill: 'Basics',
  },
  {
    skillId: 1161,
    title: 'Intermediate Taekwondo Kicks',
    emoji: '🦵',
    description: 'Master intermediate taekwondo kicking techniques',
    difficulty: 'intermediate',
    duration: '16 min',
    points: 16,
    drills: [2121], // Intermediate Taekwondo Kicks
    sport: 'taekwondo',
    skill: 'Kicks',
  },
  {
    skillId: 1162,
    title: 'Advanced Taekwondo Techniques',
    emoji: '⚡',
    description: 'Master advanced taekwondo techniques and combinations',
    difficulty: 'advanced',
    duration: '17 min',
    points: 17,
    drills: [2122], // Advanced Taekwondo Techniques
    sport: 'taekwondo',
    skill: 'Techniques',
  },
  {
    skillId: 1163,
    title: 'Beginner Taekwondo Stances',
    emoji: '☯',
    description: 'Learn fundamental taekwondo stances and positions',
    difficulty: 'beginner',
    duration: '14 min',
    points: 14,
    drills: [2124], // Beginner Taekwondo Stances
    sport: 'taekwondo',
    skill: 'Stances',
  },
  {
    skillId: 1164,
    title: 'Intermediate Taekwondo Footwork',
    emoji: '☯',
    description: 'Master intermediate taekwondo footwork and movement',
    difficulty: 'intermediate',
    duration: '15 min',
    points: 15,
    drills: [2125], // Intermediate Taekwondo Footwork
    sport: 'taekwondo',
    skill: 'Footwork',
  },
  {
    skillId: 1165,
    title: 'Advanced Taekwondo Combinations',
    emoji: '☯',
    description: 'Master advanced taekwondo combinations and sequences',
    difficulty: 'advanced',
    duration: '16 min',
    points: 16,
    drills: [2126], // Advanced Taekwondo Combinations
    sport: 'taekwondo',
    skill: 'Combinations',
  },
  {
    skillId: 1166,
    title: 'Beginner Taekwondo Defense',
    emoji: '☯',
    description: 'Learn fundamental taekwondo defense and blocking',
    difficulty: 'beginner',
    duration: '13 min',
    points: 13,
    drills: [2127], // Beginner Taekwondo Defense
    sport: 'taekwondo',
    skill: 'Defense',
  },
  {
    skillId: 1167,
    title: 'Intermediate Taekwondo Sparring',
    emoji: '🥊',
    description: 'Master intermediate taekwondo sparring techniques',
    difficulty: 'intermediate',
    duration: '16 min',
    points: 16,
    drills: [2128], // Intermediate Taekwondo Sparring
    sport: 'taekwondo',
    skill: 'Sparring',
  },
  {
    skillId: 1168,
    title: 'Advanced Taekwondo Forms',
    emoji: '☯',
    description: 'Master advanced taekwondo forms and patterns',
    difficulty: 'advanced',
    duration: '15 min',
    points: 15,
    drills: [2129], // Advanced Taekwondo Forms
    sport: 'taekwondo',
    skill: 'Forms',
  },

  // ============================================================================
  // TAEKWONDO COMPLETE WORKOUTS (Combined Skills)
  // ============================================================================

  {
    skillId: 1169,
    title: 'Complete Taekwondo - Beginner',
    emoji: '☯',
    description: 'Complete beginner taekwondo training session',
    difficulty: 'beginner',
    duration: '43 min',
    points: 43,
    drills: [2120, 2124, 2127], // Basics + Stances + Defense
    sport: 'taekwondo',
    skill: 'Complete',
  },
  {
    skillId: 1170,
    title: 'Complete Taekwondo - Intermediate',
    emoji: '☯',
    description: 'Complete intermediate taekwondo training session',
    difficulty: 'intermediate',
    duration: '47 min',
    points: 47,
    drills: [2121, 2125, 2128], // Kicks + Footwork + Sparring
    sport: 'taekwondo',
    skill: 'Complete',
  },
  {
    skillId: 1171,
    title: 'Complete Taekwondo - Advanced',
    emoji: '☯',
    description: 'Complete advanced taekwondo training session',
    difficulty: 'advanced',
    duration: '48 min',
    points: 48,
    drills: [2122, 2126, 2129], // Techniques + Combinations + Forms
    sport: 'taekwondo',
    skill: 'Complete',
  },
  {
    skillId: 1172,
    title: 'Taekwondo Championship',
    emoji: '🏆',
    description: 'Complete taekwondo championship training session',
    difficulty: 'advanced',
    duration: '19 min',
    points: 19,
    drills: [2130], // Complete Taekwondo Championship
    sport: 'taekwondo',
    skill: 'Championship',
  },

  // ============================================================================
  // MARTIAL ARTS SKILLS (Individual Skills)
  // ============================================================================

  {
    skillId: 1137,
    title: 'Beginner Stances',
    emoji: '🥷',
    description: 'Learn fundamental martial arts stances',
    difficulty: 'beginner',
    duration: '17 min',
    points: 17,
    drills: [2021], // Beginner Stances
    sport: 'martial-arts',
  },
  {
    skillId: 1138,
    title: 'Intermediate Stances',
    emoji: '🥷',
    description: 'Master intermediate martial arts stances',
    difficulty: 'intermediate',
    duration: '18 min',
    points: 18,
    drills: [2022], // Intermediate Stances
    sport: 'martial-arts',
  },
  {
    skillId: 1139,
    title: 'Advanced Stances',
    emoji: '🥷',
    description: 'Master advanced martial arts stances',
    difficulty: 'advanced',
    duration: '15 min',
    points: 15,
    drills: [2023], // Advanced Stances
    sport: 'martial-arts',
  },
  {
    skillId: 1140,
    title: 'Beginner Strikes',
    emoji: '🥷',
    description: 'Learn fundamental martial arts strikes',
    difficulty: 'beginner',
    duration: '18 min',
    points: 18,
    drills: [2024], // Beginner Strikes
    sport: 'martial-arts',
  },
  {
    skillId: 1141,
    title: 'Intermediate Strikes',
    emoji: '🥷',
    description: 'Master intermediate martial arts strikes',
    difficulty: 'intermediate',
    duration: '20 min',
    points: 20,
    drills: [2025], // Intermediate Strikes
    sport: 'martial-arts',
  },
  {
    skillId: 1142,
    title: 'Advanced Strikes',
    emoji: '🥷',
    description: 'Master advanced martial arts strikes',
    difficulty: 'advanced',
    duration: '18 min',
    points: 18,
    drills: [2026], // Advanced Strikes
    sport: 'martial-arts',
  },
  {
    skillId: 1143,
    title: 'Beginner Blocks',
    emoji: '🥷',
    description: 'Learn fundamental martial arts blocks',
    difficulty: 'beginner',
    duration: '15 min',
    points: 15,
    drills: [2027], // Beginner Blocks
    sport: 'martial-arts',
  },
  {
    skillId: 1144,
    title: 'Intermediate Blocks',
    emoji: '🥷',
    description: 'Master intermediate martial arts blocks',
    difficulty: 'intermediate',
    duration: '22 min',
    points: 22,
    drills: [2028], // Intermediate Blocks
    sport: 'martial-arts',
  },
  {
    skillId: 1145,
    title: 'Advanced Blocks',
    emoji: '🥷',
    description: 'Master advanced martial arts blocks',
    difficulty: 'advanced',
    duration: '18 min',
    points: 18,
    drills: [2029], // Advanced Blocks
    sport: 'martial-arts',
  },

  // ============================================================================
  // MARTIAL ARTS COMPLETE WORKOUTS (Combined Skills)
  // ============================================================================

  {
    skillId: 1146,
    title: 'Complete Martial Arts - Beginner',
    emoji: '🥷',
    description:
      'Master all beginner martial arts skills in one comprehensive session',
    difficulty: 'beginner',
    duration: '50 min',
    points: 50,
    drills: [2021, 2024, 2027], // Beginner Stances + Strikes + Blocks
    sport: 'martial-arts',
  },
  {
    skillId: 1147,
    title: 'Complete Martial Arts - Intermediate',
    emoji: '🥷',
    description:
      'Master all intermediate martial arts skills in one comprehensive session',
    difficulty: 'intermediate',
    duration: '59 min',
    points: 59,
    drills: [2022, 2025, 2028], // Intermediate Stances + Strikes + Blocks
    sport: 'martial-arts',
  },
  {
    skillId: 1148,
    title: 'Complete Martial Arts - Advanced',
    emoji: '🥷',
    description:
      'Master all advanced martial arts skills in one comprehensive session',
    difficulty: 'advanced',
    duration: '61 min',
    points: 61,
    drills: [2023, 2026, 2029], // Advanced Stances + Strikes + Blocks
    sport: 'martial-arts',
  },

  // ============================================================================
  // BOXING SKILLS (Individual Skills)
  // ============================================================================

  {
    skillId: 1120,
    title: 'Beginner Boxing Basics',
    emoji: '🥊',
    description: 'Learn fundamental boxing techniques',
    difficulty: 'beginner',
    duration: '18 min',
    points: 18,
    drills: [2090], // Beginner Boxing Basics
    sport: 'boxing',
  },
  {
    skillId: 1121,
    title: 'Intermediate Boxing Basics',
    emoji: '🥊',
    description: 'Master intermediate boxing techniques',
    difficulty: 'intermediate',
    duration: '45 min',
    points: 45,
    drills: [2091], // Intermediate Boxing Basics
    sport: 'boxing',
  },
  {
    skillId: 1122,
    title: 'Advanced Boxing Basics',
    emoji: '🥊',
    description: 'Master advanced boxing techniques',
    difficulty: 'advanced',
    duration: '30 min',
    points: 30,
    drills: [2092], // Advanced Boxing Basics
    sport: 'boxing',
  },
  {
    skillId: 1123,
    title: 'Beginner Boxing Footwork',
    emoji: '🥊',
    description: 'Learn basic boxing movement and footwork',
    difficulty: 'beginner',
    duration: '30 min',
    points: 30,
    drills: [2093], // Beginner Boxing Footwork
    sport: 'boxing',
  },
  {
    skillId: 1124,
    title: 'Intermediate Boxing Footwork',
    emoji: '🥊',
    description: 'Master intermediate boxing footwork',
    difficulty: 'intermediate',
    duration: '30 min',
    points: 30,
    drills: [2094], // Intermediate Boxing Footwork
    sport: 'boxing',
  },
  {
    skillId: 1125,
    title: 'Advanced Boxing Footwork',
    emoji: '🥊',
    description: 'Master advanced boxing footwork',
    difficulty: 'advanced',
    duration: '30 min',
    points: 30,
    drills: [2095], // Advanced Boxing Footwork
    sport: 'boxing',
  },
  {
    skillId: 1126,
    title: 'Beginner Boxing Defense',
    emoji: '🥊',
    description: 'Learn basic defensive boxing techniques',
    difficulty: 'beginner',
    duration: '22 min',
    points: 22,
    drills: [2096], // Beginner Boxing Defense
    sport: 'boxing',
  },
  {
    skillId: 1127,
    title: 'Intermediate Boxing Defense',
    emoji: '🥊',
    description: 'Master intermediate defensive boxing techniques',
    difficulty: 'intermediate',
    duration: '28 min',
    points: 28,
    drills: [2097], // Intermediate Boxing Defense
    sport: 'boxing',
  },
  {
    skillId: 1128,
    title: 'Advanced Boxing Defense',
    emoji: '🥊',
    description: 'Master advanced defensive boxing techniques',
    difficulty: 'advanced',
    duration: '28 min',
    points: 28,
    drills: [2098], // Advanced Boxing Defense
    sport: 'boxing',
  },
  {
    skillId: 1129,
    title: 'Boxing Masterclass',
    emoji: '🥊',
    description:
      'Complete boxing training session with all advanced techniques',
    difficulty: 'advanced',
    duration: '60 min',
    points: 60,
    drills: [2099], // Complete Boxing
    sport: 'boxing',
  },

  // ============================================================================
  // BOXING COMPLETE WORKOUTS (Combined Skills)
  // ============================================================================

  {
    skillId: 1130,
    title: 'Complete Boxing - Beginner',
    emoji: '🥊',
    description:
      'Master all beginner boxing skills in one comprehensive session',
    difficulty: 'beginner',
    duration: '70 min',
    points: 70,
    drills: [2090, 2093, 2096], // Beginner Basics + Footwork + Defense
    sport: 'boxing',
  },
  {
    skillId: 1131,
    title: 'Complete Boxing - Intermediate',
    emoji: '🥊',
    description:
      'Master all intermediate boxing skills in one comprehensive session',
    difficulty: 'intermediate',
    duration: '103 min',
    points: 103,
    drills: [2091, 2094, 2097], // Intermediate Basics + Footwork + Defense
    sport: 'boxing',
  },
  {
    skillId: 1132,
    title: 'Complete Boxing - Advanced',
    emoji: '🥊',
    description:
      'Master all advanced boxing skills in one comprehensive session',
    difficulty: 'advanced',
    duration: '88 min',
    points: 88,
    drills: [2092, 2095, 2098], // Advanced Basics + Footwork + Defense
    sport: 'boxing',
  },
];

// Helper function to get skills by sport
export const getSkillsBySport = (sport) => {
  return newSkills.filter((skill) => skill.sport === sport);
};

// Helper function to get skill by ID
export const getSkillById = (skillId) => {
  return newSkills.find((skill) => skill.skillId === skillId);
};

// Helper function to get all skills
export const getAllSkills = () => {
  return newSkills;
};

// Export individual running technique skills
export const running_form_skill = newSkills.find(
  (skill) => skill.skillId === 1150
);
export const running_speed_agility_skill = newSkills.find(
  (skill) => skill.skillId === 1151
);
export const running_beginner_endurance_skill = newSkills.find(
  (skill) => skill.skillId === 1152
);
export const running_intermediate_endurance_skill = newSkills.find(
  (skill) => skill.skillId === 1153
);
export const running_complete_beginner_skill = newSkills.find(
  (skill) => skill.skillId === 1154
);
export const running_complete_intermediate_skill = newSkills.find(
  (skill) => skill.skillId === 1155
);

// Export individual taekwondo skills
export const taekwondo_basics_skill = newSkills.find(
  (skill) => skill.skillId === 1160
);
export const taekwondo_kicks_skill = newSkills.find(
  (skill) => skill.skillId === 1161
);
export const taekwondo_techniques_skill = newSkills.find(
  (skill) => skill.skillId === 1162
);
export const taekwondo_stances_skill = newSkills.find(
  (skill) => skill.skillId === 1163
);
export const taekwondo_footwork_skill = newSkills.find(
  (skill) => skill.skillId === 1164
);
export const taekwondo_combinations_skill = newSkills.find(
  (skill) => skill.skillId === 1165
);
export const taekwondo_defense_skill = newSkills.find(
  (skill) => skill.skillId === 1166
);
export const taekwondo_sparring_skill = newSkills.find(
  (skill) => skill.skillId === 1167
);
export const taekwondo_forms_skill = newSkills.find(
  (skill) => skill.skillId === 1168
);
export const taekwondo_complete_beginner_skill = newSkills.find(
  (skill) => skill.skillId === 1169
);
export const taekwondo_complete_intermediate_skill = newSkills.find(
  (skill) => skill.skillId === 1170
);
export const taekwondo_complete_advanced_skill = newSkills.find(
  (skill) => skill.skillId === 1171
);
export const taekwondo_championship_skill = newSkills.find(
  (skill) => skill.skillId === 1172
);

// Export individual yoga skills
export const yoga_basics_beginner_skill = newSkills.find(
  (skill) => skill.skillId === 1062
);
export const yoga_basics_intermediate_skill = newSkills.find(
  (skill) => skill.skillId === 1063
);
export const yoga_basics_advanced_skill = newSkills.find(
  (skill) => skill.skillId === 1064
);
export const yoga_complete_beginner_skill = newSkills.find(
  (skill) => skill.skillId === 1190
);
export const yoga_complete_intermediate_skill = newSkills.find(
  (skill) => skill.skillId === 1191
);
export const yoga_complete_advanced_skill = newSkills.find(
  (skill) => skill.skillId === 1192
);

// Export individual volleyball skills
export const volleyball_beginner_passing_skill = newSkills.find(
  (skill) => skill.skillId === 1046
);
export const volleyball_intermediate_passing_skill = newSkills.find(
  (skill) => skill.skillId === 1047
);
export const volleyball_advanced_passing_skill = newSkills.find(
  (skill) => skill.skillId === 1048
);
export const volleyball_beginner_setting_skill = newSkills.find(
  (skill) => skill.skillId === 1049
);
export const volleyball_intermediate_setting_skill = newSkills.find(
  (skill) => skill.skillId === 1050
);
export const volleyball_advanced_setting_skill = newSkills.find(
  (skill) => skill.skillId === 1051
);
export const volleyball_beginner_serving_skill = newSkills.find(
  (skill) => skill.skillId === 1052
);
export const volleyball_intermediate_serving_skill = newSkills.find(
  (skill) => skill.skillId === 1053
);
export const volleyball_advanced_serving_skill = newSkills.find(
  (skill) => skill.skillId === 1054
);
export const volleyball_complete_individual_skill = newSkills.find(
  (skill) => skill.skillId === 1055
);

// Export individual karate skills
export const karate_beginner_stances_skill = newSkills.find(
  (skill) => skill.skillId === 1036
);
export const karate_intermediate_stances_skill = newSkills.find(
  (skill) => skill.skillId === 1037
);
export const karate_advanced_stances_skill = newSkills.find(
  (skill) => skill.skillId === 1038
);
export const karate_beginner_strikes_skill = newSkills.find(
  (skill) => skill.skillId === 1039
);
export const karate_intermediate_strikes_skill = newSkills.find(
  (skill) => skill.skillId === 1040
);
export const karate_advanced_strikes_skill = newSkills.find(
  (skill) => skill.skillId === 1041
);
export const karate_beginner_blocks_skill = newSkills.find(
  (skill) => skill.skillId === 1042
);
export const karate_intermediate_blocks_skill = newSkills.find(
  (skill) => skill.skillId === 1043
);
export const karate_advanced_blocks_skill = newSkills.find(
  (skill) => skill.skillId === 1044
);
export const karate_complete_individual_skill = newSkills.find(
  (skill) => skill.skillId === 1045
);

// Export combined karate skills
export const karate_beginner_combat_skill = newSkills.find(
  (skill) => skill.skillId === 1193
);
export const karate_intermediate_combat_skill = newSkills.find(
  (skill) => skill.skillId === 1194
);
export const karate_advanced_combat_skill = newSkills.find(
  (skill) => skill.skillId === 1195
);

// Export individual dance skills
export const dance_beginner_movement_skill = newSkills.find(
  (skill) => skill.skillId === 1200
);
export const dance_intermediate_movement_skill = newSkills.find(
  (skill) => skill.skillId === 1201
);
export const dance_advanced_movement_skill = newSkills.find(
  (skill) => skill.skillId === 1202
);
export const dance_beginner_rhythm_skill = newSkills.find(
  (skill) => skill.skillId === 1203
);
export const dance_intermediate_rhythm_skill = newSkills.find(
  (skill) => skill.skillId === 1204
);
export const dance_robot_rhythm_skill = newSkills.find(
  (skill) => skill.skillId === 1205
);
export const dance_beginner_choreography_skill = newSkills.find(
  (skill) => skill.skillId === 1206
);
export const dance_intermediate_choreography_skill = newSkills.find(
  (skill) => skill.skillId === 1207
);
export const dance_advanced_choreography_skill = newSkills.find(
  (skill) => skill.skillId === 1208
);
export const dance_complete_individual_skill = newSkills.find(
  (skill) => skill.skillId === 1209
);

// Export combined dance skills
export const dance_beginner_combined_skill = newSkills.find(
  (skill) => skill.skillId === 1210
);
export const dance_intermediate_combined_skill = newSkills.find(
  (skill) => skill.skillId === 1211
);
export const dance_advanced_combined_skill = newSkills.find(
  (skill) => skill.skillId === 1212
);

// Export individual ballet skills
export const ballet_beginner_basics_skill = newSkills.find(
  (skill) => skill.skillId === 1220
);
export const ballet_intermediate_basics_skill = newSkills.find(
  (skill) => skill.skillId === 1221
);
export const ballet_advanced_basics_skill = newSkills.find(
  (skill) => skill.skillId === 1222
);
export const ballet_beginner_movement_skill = newSkills.find(
  (skill) => skill.skillId === 1223
);
export const ballet_intermediate_movement_skill = newSkills.find(
  (skill) => skill.skillId === 1224
);
export const ballet_advanced_movement_skill = newSkills.find(
  (skill) => skill.skillId === 1225
);
export const ballet_beginner_grace_skill = newSkills.find(
  (skill) => skill.skillId === 1226
);
export const ballet_intermediate_grace_skill = newSkills.find(
  (skill) => skill.skillId === 1227
);
export const ballet_advanced_grace_skill = newSkills.find(
  (skill) => skill.skillId === 1228
);
export const ballet_complete_individual_skill = newSkills.find(
  (skill) => skill.skillId === 1229
);

// Export combined ballet skills
export const ballet_beginner_combined_skill = newSkills.find(
  (skill) => skill.skillId === 1230
);
export const ballet_intermediate_combined_skill = newSkills.find(
  (skill) => skill.skillId === 1231
);
export const ballet_advanced_combined_skill = newSkills.find(
  (skill) => skill.skillId === 1232
);

// Export individual baseball skills
export const baseball_beginner_hitting_skill = newSkills.find(
  (skill) => skill.skillId === 1240
);
export const baseball_intermediate_hitting_skill = newSkills.find(
  (skill) => skill.skillId === 1241
);
export const baseball_advanced_hitting_skill = newSkills.find(
  (skill) => skill.skillId === 1242
);
export const baseball_beginner_fielding_skill = newSkills.find(
  (skill) => skill.skillId === 1243
);
export const baseball_intermediate_fielding_skill = newSkills.find(
  (skill) => skill.skillId === 1244
);
export const baseball_beginner_throwing_skill = newSkills.find(
  (skill) => skill.skillId === 1245
);
export const baseball_intermediate_throwing_skill = newSkills.find(
  (skill) => skill.skillId === 1246
);
export const baseball_advanced_throwing_skill = newSkills.find(
  (skill) => skill.skillId === 1247
);
export const baseball_complete_individual_skill = newSkills.find(
  (skill) => skill.skillId === 1248
);

// Export combined baseball skills
export const baseball_beginner_combined_skill = newSkills.find(
  (skill) => skill.skillId === 1250
);
export const baseball_intermediate_combined_skill = newSkills.find(
  (skill) => skill.skillId === 1251
);
export const baseball_advanced_combined_skill = newSkills.find(
  (skill) => skill.skillId === 1252
);

// Export partner baseball skills
export const baseball_partner_toss_catch_skill = newSkills.find(
  (skill) => skill.skillId === 1253
);
export const baseball_partner_grounder_scoop_skill = newSkills.find(
  (skill) => skill.skillId === 1254
);
export const baseball_partner_throw_accuracy_skill = newSkills.find(
  (skill) => skill.skillId === 1255
);
export const baseball_partner_quick_hands_skill = newSkills.find(
  (skill) => skill.skillId === 1256
);
export const baseball_partner_pop_fly_skill = newSkills.find(
  (skill) => skill.skillId === 1257
);
export const baseball_partner_relay_skill = newSkills.find(
  (skill) => skill.skillId === 1258
);

// Export basketball skills
export const basketball_beginner_dribbling_skill = newSkills.find(
  (skill) => skill.skillId === 1024
);
export const basketball_intermediate_dribbling_skill = newSkills.find(
  (skill) => skill.skillId === 1025
);
export const basketball_advanced_dribbling_skill = newSkills.find(
  (skill) => skill.skillId === 1026
);
export const basketball_beginner_shooting_skill = newSkills.find(
  (skill) => skill.skillId === 1027
);
export const basketball_intermediate_shooting_skill = newSkills.find(
  (skill) => skill.skillId === 1028
);
export const basketball_beginner_defense_skill = newSkills.find(
  (skill) => skill.skillId === 1029
);
export const basketball_intermediate_defense_skill = newSkills.find(
  (skill) => skill.skillId === 1030
);
export const basketball_advanced_defense_skill = newSkills.find(
  (skill) => skill.skillId === 1031
);
export const basketball_complete_individual_skill = newSkills.find(
  (skill) => skill.skillId === 1032
);

// Basketball Combined Skills
export const basketball_beginner_complete_skill = newSkills.find(
  (skill) => skill.skillId === 1033
);
export const basketball_intermediate_complete_skill = newSkills.find(
  (skill) => skill.skillId === 1034
);
export const basketball_advanced_complete_skill = newSkills.find(
  (skill) => skill.skillId === 1035
);
